import { createContext, ReactNode, useState } from "react";
import { isAtmSearchFormEmpty, isBillingSearchFormEmpty, isDataLineSearchFormEmpty, isDCompanySearchFormEmpty, isDepartmentSearchFormEmpty, 
  isEstablishmentSearchFormEmpty, isNodeSearchFormEmpty, isPhoneCenterSearchFormEmpty, isPhoneLineSearchFormEmpty, isTypeOfAtmSearchForm, 
  isTypeOfBillingSearchForm, 
  isTypeOfDataLineSearchForm, 
  isTypeOfDCompanySearchForm, isTypeOfDepartmentSearchForm, isTypeOfEstablishmentSearchForm, 
  isTypeOfNodeSearchForm, 
  isTypeOfPhoneCenterSearchForm, 
  isTypeOfPhoneLineSearchForm, isTypeOfUnitSearchForm, isUnitSearchFormEmpty 
} from "./SydFilterTypeChecker";

const defaultFilterProps = {
  toggleFilterVisibility: () => {}, 
  removeFilterVisibility: () => {},
  clearAllFilters: () => {},
  checkFilterIsActive: () => false,
  activeFilters: {} as IFilterType,
  saveFilters: (filters: IFilterType) => {},
  isTypeOfEstablishmentSearchForm: (filters: IFilterType) => false,
  isFilterVisible: false,
  isFilterSubmitedOnce: false
}

export const SydFilterContext = createContext<ISydFilterContextType>(defaultFilterProps);
  const SydFilterProvider = (props : ISydFilterProviderProps) => {
    const [defaultFilterData, setDefaultFilterData] = useState<IFilterType>(props.defaultFilterData);
    const [isFilterVisible, setIsFilterVisible] = useState<boolean>(false);
    const [activeFilters, setActiveFilters] = useState<IFilterType>(props.defaultFilterData);
    const [isFilterSubmitedOnce, setIsFilterSubmitedOnce] = useState<boolean>(false);

    const toggleFilterVisibility = () => {
      setIsFilterVisible(!isFilterVisible);
    };

    const removeFilterVisibility = () =>{
      setIsFilterVisible(false);
    }

    const clearAllFilters = () => {
      setActiveFilters(defaultFilterData);
      setIsFilterSubmitedOnce(false);
    }

    const checkFilterIsActive = () => {
      if(isTypeOfEstablishmentSearchForm(activeFilters)) 
        return !isEstablishmentSearchFormEmpty(activeFilters);

      if(isTypeOfDCompanySearchForm(activeFilters)) 
        return !isDCompanySearchFormEmpty(activeFilters);

      if(isTypeOfDepartmentSearchForm(activeFilters)) 
        return !isDepartmentSearchFormEmpty(activeFilters);

      if(isTypeOfUnitSearchForm(activeFilters)) 
        return !isUnitSearchFormEmpty(activeFilters); 

      if(isTypeOfAtmSearchForm(activeFilters)) 
        return !isAtmSearchFormEmpty(activeFilters);

      if(isTypeOfPhoneLineSearchForm(activeFilters)) 
        return !isPhoneLineSearchFormEmpty(activeFilters);

      if(isTypeOfPhoneCenterSearchForm(activeFilters)) 
        return !isPhoneCenterSearchFormEmpty(activeFilters);

      if(isTypeOfNodeSearchForm(activeFilters)) 
        return !isNodeSearchFormEmpty(activeFilters);

      if(isTypeOfNodeSearchForm(activeFilters)) 
        return !isNodeSearchFormEmpty(activeFilters);

      if(isTypeOfDataLineSearchForm(activeFilters)) 
        return !isDataLineSearchFormEmpty(activeFilters);

      if(isTypeOfBillingSearchForm(activeFilters)) 
        return !isBillingSearchFormEmpty(activeFilters);
      
      return false;
    }

    const saveFilters = (filters: IFilterType) => {
      if(!isFilterSubmitedOnce){
        setIsFilterSubmitedOnce(true);
      }
      setActiveFilters(filters);
    }

    const porviderValue = {
      toggleFilterVisibility, 
      removeFilterVisibility,
      clearAllFilters,
      checkFilterIsActive,
      activeFilters,
      saveFilters,
      isFilterVisible,
      isFilterSubmitedOnce
    }

    return (
      <SydFilterContext.Provider value={porviderValue}>
          {props.children}
      </SydFilterContext.Provider>
    )
      
  }

interface ISydFilterContextType {
  toggleFilterVisibility: () => void;
  removeFilterVisibility: () => void;
  clearAllFilters: () => void;
  activeFilters: IFilterType;
  saveFilters: (filters: IFilterType) => void;
  checkFilterIsActive: () => boolean;
  isFilterVisible: boolean;
  isFilterSubmitedOnce: boolean;
}

interface ISydFilterProviderProps {
  children: ReactNode;
  defaultFilterData: IFilterType;
}

export default SydFilterProvider;
